import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {Navigate, Route, Routes} from "react-router-dom";
import Config from "views/app/config/index.jsx";
import Layout from "views/app/layout.jsx";
import Logout from "views/app/logout.jsx";
import Dashboard from "views/app/dashboard/index.jsx";
import OAuthAPI from "views/app/api/index.jsx";
import AdminUsers from "views/app/admin/users.jsx";
import AdminBalance from "views/app/admin/balance.jsx";
import AdminDisneyTokens from "views/app/admin/disneyTokens.jsx";
import AdminNuplinTokens from "views/app/admin/nuplinTokens.jsx";
import AdminProducts from "views/app/admin/products.jsx";
import AdminAppConfig from "views/app/admin/appConfig.jsx";
import AdminReconciliations from "views/app/admin/reconciliations.jsx";
import AdminSales from "views/app/admin/sales.jsx";
import TigoGestion from "views/app/tigo-gestion/index.jsx";
import Disney from "views/app/disney/index.jsx";

export default function Application(props) {
  const appDataStore = useAppDataStore()
  const {user} = appDataStore
  const mainPage = user.passwordChanged ? 'dashboard' : 'config'
  return (
    <Routes>
      <Route path={'/'} index element={<Navigate to={mainPage}/>}/>
      <Route path="*" element={<Layout {...props} />}>
        <Route path={'dashboard'} element={<Dashboard {...props} />}/>
        <Route path={'providers'} element={<TigoGestion {...props} />}/>
        <Route path={'disney'} element={<Disney {...props} />}/>
        <Route path={'config'} element={<Config {...props} />}/>
        <Route path={'api'} element={<OAuthAPI {...props} />}/>
        <Route path={'admin/users'} element={<AdminUsers {...props} />}/>
        <Route path={'admin/balance'} element={<AdminBalance {...props} />}/>
        <Route path={'admin/sales'} element={<AdminSales {...props} />}/>
        <Route path={'admin/disney-tokens'} element={<AdminDisneyTokens {...props} />}/>
        <Route path={'admin/nuplin-tokens'} element={<AdminNuplinTokens {...props} />}/>
        <Route path={'admin/products'} element={<AdminProducts {...props} />}/>
        <Route path={'admin/config'} element={<AdminAppConfig {...props} />}/>
        <Route path={'admin/reconciliations'} element={<AdminReconciliations {...props} />}/>
        <Route path={'logout'} element={<Logout {...props} />}/>
        <Route path={'*'} element={<Navigate to={'./'}/>}/>
      </Route>
    </Routes>
  )
}